import { render, staticRenderFns } from "./note-toc.vue?vue&type=template&id=b27c56e4"
import script from "./note-toc.vue?vue&type=script&lang=js"
export * from "./note-toc.vue?vue&type=script&lang=js"
import style0 from "./note-toc.vue?vue&type=style&index=0&id=b27c56e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports